import { AdminClientTemplates } from './AdminClientTemplates';

export default AdminClientTemplates;